import * as go from 'gojs';
import { LinkLabelOnPathDraggingTool } from '../tools/LinkLabelDraggingOnPathTool';
import { UnitTypes } from 'unitData/types';

const $ = go.GraphObject.make;

const createTempFromNode = () => {
  return $(
    go.Node,
    { layerName: 'Tool' },
    $(
      go.Panel,
      'Auto',
      { width: 32, height: 32, name: 'FROMPANEL' },
      $(go.Shape, 'Circle', {
        stroke: null,
        strokeWidth: 0,
        fill: '#C0E6FF',
        name: 'TEMPSHAPE',
      }),
      $(go.Shape, {
        stroke: null,
        fromLinkable: true,
        toMaxLinks: 1,
        fromMaxLinks: 1,
        cursor: 'pointer',
        strokeWidth: 0,
        fill: '#327DFF',
        name: 'OUTPUTPORT',
        portId: '',
      }),
      $(go.TextBlock, {
        stroke: 'white',
        name: 'TEXTBLOCK',
        font: '500 6pt Sandvik Sans Text',
        alignment: go.Spot.Center,
        verticalAlignment: go.Spot.Center,
      }),
    ),
  );
};

const createTempToNode = () => {
  return $(
    go.Node,
    { layerName: 'Tool' },
    $(
      go.Panel,
      'Auto',
      { width: 32, height: 32 },
      $(go.Shape, 'Circle', {
        stroke: null,
        strokeWidth: 0,
        fill: '#C0E6FF',
        name: 'TEMPSHAPE',
      }),
      $(go.Shape, 'TriangleDown', {
        stroke: null,
        strokeWidth: 0,
        toLinkable: true,
        toMaxLinks: 1,
        fromMaxLinks: 1,
        cursor: 'pointer',
        desiredSize: new go.Size(12, 12),
        fill: '#327DFF',
        toSpot: go.Spot.Top,
        portId: '',
      }),
    ),
  );
};

const createTemporaryLink = () => {
  return $(
    go.Link,
    { layerName: 'Tool', toSpot: go.Spot.Top },
    $(go.Shape, { stroke: '#327DFF', strokeWidth: 1 }),
  );
};

const customDoNoLink = function (
  this: go.LinkingTool,
  _fromnode: go.Node | null,
  _fromport: go.GraphObject | null,
  _tonode: go.Node | null,
  _toport: go.GraphObject | null,
) {
  this.transactionResult = '';
};

const customPortTargeted = function (
  this: go.LinkingTool,
  node: go.Node | null,
  port: go.GraphObject | null,
  tempNode: go.Node,
  tempPort: go.GraphObject,
  _toEnd: boolean,
) {
  if (port) {
    if (port.name.toString().startsWith('D')) {
      this.temporaryFromPort.setProperties({
        figure: 'RoundedRectangle',
        desiredSize: new go.Size(22, 12),
      });
      this.temporaryFromNode.findObject('TEXTBLOCK')?.setProperties({
        text: port.name,
      });
    } else if (
      port.name === 'INPUTPORT' &&
      node?.category === UnitTypes.CONVENTIONAL_SCREEN
    ) {
      this.temporaryFromPort.setProperties({
        figure: 'Circle',
        desiredSize: new go.Size(12, 12),
      });
      this.temporaryFromNode.findObject('TEXTBLOCK')?.setProperties({
        text: '',
      });
    } else if (port.name === 'INPUTPORT') {
      this.temporaryToPort.setProperties({
        figure: 'TriangleDown',
        desiredSize: new go.Size(12, 12),
      });
    } else {
      this.temporaryToPort.setProperties({
        figure: 'TriangleDown',
        desiredSize: new go.Size(12, 12),
      });
      this.temporaryFromNode.findObject('TEXTBLOCK')?.setProperties({
        text: '',
      });
      this.temporaryFromPort.setProperties({
        figure: 'Circle',
        desiredSize: new go.Size(12, 12),
      });
    }
    if (
      node &&
      (node.findLinksInto(port.portId).count === 1 ||
        node.findLinksOutOf(port.portId).count === 1)
    ) {
      tempNode.findObject('TEMPSHAPE')?.setProperties({
        fill: '#F9CBC7',
      });
      tempPort.setProperties({
        fill: '#E22F1D',
      });
    } else {
      tempNode.findObject('TEMPSHAPE')?.setProperties({
        fill: '#C0E6FF',
      });
      tempPort.setProperties({
        fill: '#327DFF',
      });
    }
  }
  tempNode.opacity = node ? 1.0 : 0.0;
};

export const configureLinkingTool = (diagram: go.Diagram) => {
  const tempFromNode = createTempFromNode();
  const tempToNode = createTempToNode();
  const temporaryLink = createTemporaryLink();

  diagram.toolManager.linkingTool.temporaryFromNode = tempFromNode;
  diagram.toolManager.linkingTool.temporaryFromPort = tempFromNode.port;
  diagram.toolManager.linkingTool.temporaryToNode = tempToNode;
  diagram.toolManager.linkingTool.temporaryToPort = tempToNode.port;
  diagram.toolManager.linkingTool.temporaryLink = temporaryLink;

  diagram.toolManager.linkingTool.doNoLink = customDoNoLink;
  diagram.toolManager.linkingTool.diagram.toolManager.linkingTool.portTargeted =
    customPortTargeted;

  diagram.toolManager.mouseMoveTools.insertAt(
    0,
    new LinkLabelOnPathDraggingTool(),
  );
};
